import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AppShell } from "./AppShell";
import { AccountPage } from "../pages/AccountPage";
import { AuthPage } from "../pages/AuthPage";
import { FinancePage } from "../pages/FinancePage";
import { HomePage } from "../pages/HomePage";
import { MarketPage, ProductDetailPage } from "../pages/MarketPage";
import { MinersPage } from "../pages/MinersPage";
import {
  DepositPage,
  PayoutMethodsPage,
  TransactionsPage,
  WithdrawalHistoryPage,
  WithdrawPage,
} from "../pages/WalletPages";
import { InvitePage, TeamMembersPage, TeamPage } from "../pages/GrowthPages";
import {
  CheckinPage,
  DownloadPage,
  MessagesPage,
  LotteryHistoryPage,
  PointsPage,
  ProfilePage,
  RafflePage,
  SupportPage,
} from "../pages/EngagementPages";
import {
  CdkPage,
  CouponsPage,
  ExchangeHistoryPage,
  RedPacketsPage,
  RewardsHubPage,
} from "../pages/RewardsPages";
import {
  AboutPage,
  CompanyPage,
  RecruitmentPage,
  TeamIncomePage,
} from "../pages/InfoPages";
import { TeamTransferPage } from "../pages/TeamTransferPage";

const legacyRoutes: Record<string, string> = {
  "pages/index/index": "/",
  "pages/mall/mall": "/market",
  "pages/pledge/pledge": "/finance",
  "pages/funds/funds": "/finance",
  "pages/my/my": "/account",
  "pages/minerDeatils/minerDeatils": "/market",
  "pages/invite/invite": "/growth/invite",
  "pages/miner/miner": "/miners",
  "pages/bonus/bonus": "/rewards/cdk",
  "pages/bonus/history": "/rewards/cdk",
  "pages/exchange/exchange": "/rewards/points",
  "pages/exchange/history": "/rewards/exchange-history",
  "pages/exchange/temeExblance": "/wallet/team-transfer",
  "pages/raffle/raffle": "/rewards/raffle",
  "pages/raffle/history": "/rewards/raffle/history",
  "pages/coupon/coupon": "/rewards/coupons",
  "pages/aboutUs/aboutUs": "/about",
  "pages/company/company": "/company",
  "pages/login/login": "/auth/login",
  "pages/register/register": "/auth/register",
  "pages/checking/checking": "/account/checkin",
  "pages/msgcenter/msgcenter": "/messages",
  "pages/changeinfo/changeinfo": "/account/profile",
  "pages/changeinfo/changename": "/account/profile",
  "pages/changeinfo/changepaw": "/account/profile",
  "pages/recharge/recharge": "/wallet/deposit",
  "pages/cashOut/cashOut": "/wallet/withdraw",
  "pages/fundrecord/fundrecord": "/wallet/transactions",
  "pages/myTeam/myTeam": "/growth/team",
  "pages/myTeam/brisk": "/growth/team",
  "pages/withdrawalRecords/withdrawalRecords": "/wallet/withdrawals",
  "pages/integral/integral": "/rewards/points",
  "pages/teamIncome/teamIncome": "/growth/income",
  "pages/addCard/addCard": "/wallet/payout-methods",
  "pages/recruitminers/recruitminers": "/recruitment",
  "pages/red/red": "/rewards/red-packets",
};

function LegacyPageRedirect() {
  const location = useLocation();
  const path = location.pathname.replace(/^\/+/, "");
  return (
    <Navigate to={(legacyRoutes[path] || "/") + location.search} replace />
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/auth/login" element={<AuthPage mode="login" />} />
      <Route path="/auth/register" element={<AuthPage mode="register" />} />
      <Route path="/pages/*" element={<LegacyPageRedirect />} />
      <Route element={<AppShell />}>
        <Route index element={<HomePage />} />
        <Route path="market" element={<MarketPage />} />
        <Route path="market/:productId" element={<ProductDetailPage />} />
        <Route path="miners" element={<MinersPage />} />
        <Route path="finance" element={<FinancePage />} />
        <Route path="account" element={<AccountPage />} />
        <Route path="wallet/deposit" element={<DepositPage />} />
        <Route path="wallet/withdraw" element={<WithdrawPage />} />
        <Route path="wallet/transactions" element={<TransactionsPage />} />
        <Route path="wallet/withdrawals" element={<WithdrawalHistoryPage />} />
        <Route path="wallet/payout-methods" element={<PayoutMethodsPage />} />
        <Route path="wallet/team-transfer" element={<TeamTransferPage />} />
        <Route path="growth/team" element={<TeamPage />} />
        <Route path="growth/team/:level" element={<TeamMembersPage />} />
        <Route path="growth/invite" element={<InvitePage />} />
        <Route path="growth/income" element={<TeamIncomePage />} />
        <Route path="recruitment" element={<RecruitmentPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="company" element={<CompanyPage />} />
        <Route path="account/checkin" element={<CheckinPage />} />
        <Route path="account/profile" element={<ProfilePage />} />
        <Route path="rewards/points" element={<PointsPage />} />
        <Route path="rewards/raffle" element={<RafflePage />} />
        <Route path="rewards/raffle/history" element={<LotteryHistoryPage />} />
        <Route path="rewards" element={<RewardsHubPage />} />
        <Route path="rewards/coupons" element={<CouponsPage />} />
        <Route path="rewards/cdk" element={<CdkPage />} />
        <Route path="rewards/red-packets" element={<RedPacketsPage />} />
        <Route
          path="rewards/exchange-history"
          element={<ExchangeHistoryPage />}
        />
        <Route path="messages" element={<MessagesPage />} />
        <Route path="support" element={<SupportPage />} />
        <Route path="download" element={<DownloadPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
